module.exports = __webpack_public_path__ + "static/smart-panel-detail-ccf8f2bdac50a71ee47ceebb16aeeb80.webp";